"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _MinioPlugin = /*#__PURE__*/ _interop_require_default(require("./MinioPlugin"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const config = {
    builder: _MinioPlugin.default,
    id: 'minio',
    title: 'Minio',
    version: '0.0.5',
    logo: 'plugins/minio.png',
    description: 'MinIO is a High Performance Object Storage released under Apache License v2.0. It is API compatible with Amazon S3 cloud storage service.',
    price: 'Free',
    tags: 'Storage',
    category: 'Storage',
    inputs: {
        title: 'Configure Minio',
        items: [
            {
                key: 'endPoint',
                label: 'Minio Endpoint',
                placeholder: 'Minio Endpoint',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true,
                help_text: 'Hostnames can’t include underscores (_) due to DNS standard limitations. Update the hostname if you see an Invalid endpoint error.'
            },
            {
                key: 'port',
                label: 'Port',
                placeholder: 'Port',
                type: _nocodbsdk.XcType.Number,
                required: true
            },
            {
                key: 'bucket',
                label: 'Bucket Name',
                placeholder: 'Bucket Name',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_key',
                label: 'Access Key',
                placeholder: 'Access Key',
                type: _nocodbsdk.XcType.SingleLineText,
                required: true
            },
            {
                key: 'access_secret',
                label: 'Access Secret',
                placeholder: 'Access Secret',
                type: _nocodbsdk.XcType.Password,
                required: true
            },
            {
                key: 'ca',
                label: 'Ca',
                placeholder: 'Ca',
                type: _nocodbsdk.XcType.LongText
            },
            {
                key: 'useSSL',
                label: 'Use SSL',
                placeholder: 'Use SSL',
                type: _nocodbsdk.XcType.Checkbox,
                required: false
            }
        ],
        actions: [
            {
                label: 'Test',
                placeholder: 'Test',
                key: 'test',
                actionType: _nocodbsdk.XcActionType.TEST,
                type: _nocodbsdk.XcType.Button
            },
            {
                label: 'Save',
                placeholder: 'Save',
                key: 'save',
                actionType: _nocodbsdk.XcActionType.SUBMIT,
                type: _nocodbsdk.XcType.Button
            }
        ],
        msgOnInstall: 'Successfully configured! Attachments will now be stored in Minio.',
        msgOnUninstall: ''
    }
};
const _default = config;
